export * from "./SimplifiedPrizes.builder";
